import React, { useState, useEffect } from 'react';
import { loanProductsApi } from '../../api';
import { LoanProduct } from '../../types';
import { LoanProductCard } from '../../components/LoanProductCard';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { ErrorMessage } from '../../components/ErrorMessage';

export const LoanProducts: React.FC = () => {
  const [products, setProducts] = useState<LoanProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await loanProductsApi.getAll();
        if (response.success && response.data) {
          setProducts(response.data.products);
        }
      } catch (err: any) {
        setError(err.message || 'Failed to load loan products');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="loan-products-page">
      <div className="page-header">
        <h1>Our Loan Products</h1>
        <p>Choose from our range of flexible loan products designed to meet your needs.</p>
      </div>

      {error && <ErrorMessage message={error} onClose={() => setError('')} />}

      {products.length === 0 ? (
        <div className="empty-state">
          <p>No loan products available at the moment.</p>
        </div>
      ) : (
        <div className="products-grid">
          {products.map((product) => (
            <LoanProductCard key={product.product_id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};
